import React from 'react';

export const impressionGlobalData = {
  observer: null,
  impressionMap: new WeakMap(),
  impressed: {},
};

const defaultContextValue = {
  ref: null,
  clickID: null,
  parent: {
    id: '', // *** required prop ***
    component: '', // *** required prop *** ==> component public export name
    name: 'Page', // *** required prop *** descriptive titles or component name
    variation: '', // cta style values
    position: '',
    type: '',
    category: '',
  },
  data: {
    id: '', // *** required prop ***
    component: '', // *** required prop *** ==> component public export name
    name: 'component', // *** required prop *** ==> descriptive titles or component name
    variation: 'component', // cta style values
    position: '',
    type: '',
    category: '',
  },
};

export const ImpressionContext = React.createContext(defaultContextValue);
